(function ($) {
    'use strict';

    function submitForm() {

    }

    var advfil = $('.adv-filter').select2({
        dropdownParent: $('.adv-filter').parent(),
        minimumResultsForSearch: Infinity
    });


    var next_page = 2;
    function getAdvs(page, filter, exlude, term) {
        var alist = $('.adverts-list');
        var data = {
            'action' : 'ran_get_advs',
            'next_page' : page,
            'filter' : filter,
            'exclude' : exlude,
            'term': term
        };
        $.get(ajaxurl, data, function(response){
            console.log(response)

            if( response.success === true ) {

                if (page === '1') {
                    alist.html('');
                }
                alist.append( response.data.html );


                if( response.data.next_page > 0 ) {
                    next_page = response.data.next_page;

                    $('.adv-load-more').show();
                } else {

                    $('.adv-load-more').hide();
                    console.log('nomore')
                }
            } else {
                $('.adv-load-more').hide();
                alist.html('<h5>Skelbimų nėra</h5>');
                console.log('nomore 2')
            }

        });
        return false;
    }

    advfil.on("select2:select", function (e) {
        var which = e.params.data.id;

        $('.adv-load-more').attr('data-which', which);

        if ($('.adv-filter-wrap').data('term') !== '') {
            getAdvs('1', which, '', $('.adv-filter-wrap').data('term'));
        } else if ($('.adv-filter-wrap').data('exclude') !== '') {
            getAdvs('1', which, $('.adv-filter-wrap').data('exclude'), '');
        } else {
            getAdvs('1', which, '', '');
        }
    });

    $('.adv-load-more').on('click', function (e) {
        e.preventDefault();

        getAdvs(next_page, $(this).data('which'), $(this).data('exclude'), $(this).data('term'));
    });

    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    $('#forma.create').on('submit', function (e) {
        e.preventDefault();

        // default ajax
        var fd = new FormData();
        // var files_data = $('#images');
        // $.each($(files_data), function(i, obj) {
        //     $.each(obj.files,function(j,file){
        //         fd.append('files[' + j + ']', file);
        //     })
        // });
        $.each($('.filecheck'), function(i, obj) {
            fd.append('files[' + i + ']', obj.files[Object.keys(obj.files)[0]]);
        });
        fd.append('action', 'submit_advert');
        $(this).find('input.repadd').each(function(){
            fd.append(this.name, $(this).val());
        });
        $(this).find('textarea.repadd').each(function(){
            fd.append(this.name, $(this).val());
        });
        $(this).find('select').each(function(){
            fd.append(this.name, $(this).val());
        });
        if ($('input[name=premium]').is(':checked')) {
            fd.append('premium', 'true');
        }
        fd.append('parduoda_perka', $('input[name=parduoda_perka]:checked').val());
        fd.append('advert_create_nonce', $('#advert_create_nonce').val());
        //fd.append('type', $('input[name=type]:checked').val());

        // paid ajax
        var pd = new FormData();

        var valid = true;
        $('.required').removeClass('invalid').each(function (ind, el) {
            if ($(el).attr("id") === "contact_person_email") {
                if (!validateEmail($(el).val())) {
                    $(el).addClass('invalid');
                }
            } else {
                if ($(el).val() === '') {
                    valid = false;
                    $(el).addClass('invalid');
                }
            }
        });

        if (valid) {
            $.ajax({
                type: 'POST',
                url: ajaxurl,
                data: fd,
                dataType: 'json',
                contentType: false,
                processData: false,
                success: function (response) {
                    console.log(response);

                    pd.append('id', response);
                    if ($('input[name=premium]').is(':checked')) {
                        pd.append('type', 'paidpremium');
                    } else {
                        pd.append('type', 'paid');
                    }
                    pd.append('action', 'adv_get_payment_url');
                    pd.append('email', $('input[name=contact_person_email]').val());

                    $.ajax({
                        type: 'POST',
                        url: ajaxurl,
                        data: pd,
                        dataType: 'json',
                        contentType: false,
                        processData: false,
                        success: function (response) {
                            window.location = response;
                        }
                    });
                },
                error: function(response){
                    console.log('err' . response)
                }
            });
        }
    });

    var payingpaid = false;
    var payingpremium = false;

    $('#paid.update').on('click', function () {
        if ($(this).is(':checked')) {
            payingpaid = true;
        } else {
            payingpaid = false;
        }

        if (payingpaid || payingpremium) {
            $('.create-advert').html('Išsaugoti ir apmokėti')
        } else {
            $('.create-advert').html('Išsaugoti')
        }
    });
    $('#premium.update').on('click', function () {
        if ($(this).is(':checked')) {
            payingpremium = true;

            if (!payingpaid) {
                $('#paid.update').click().parent().addClass('priva');
            }
            $('#paid.update').parent().addClass('priva');
        } else {
            payingpremium = false;
            $('#paid.update').parent().removeClass('priva');
        }

        if (payingpaid || payingpremium) {
            $('.create-advert').html('Išsaugoti ir apmokėti')
        } else {
            $('.create-advert').html('Išsaugoti')
        }
    });

    $('#forma.update').on('submit', function (e) {
        e.preventDefault();

        var pid = $(this).data('pid');

        // default ajax
        var fd = new FormData();
        // var files_data = $('#images');
        // $.each($(files_data), function(i, obj) {
        //     $.each(obj.files,function(j,file){
        //         fd.append('files[' + j + ']', file);
        //     })
        // });
        $.each($('.filecheck'), function(i, obj) {
            fd.append('files[' + i + ']', obj.files[Object.keys(obj.files)[0]]);
        });
        fd.append('action', 'submit_advert');
        $(this).find('input.repadd').each(function(){
            fd.append(this.name, $(this).val());
        });
        $(this).find('textarea.repadd').each(function(){
            fd.append(this.name, $(this).val());
        });
        $(this).find('select').each(function(){
            fd.append(this.name, $(this).val());
        });
        fd.append('parduoda_perka', $('input[name=parduoda_perka]:checked').val());
        fd.append('advert_create_nonce', $('#advert_create_nonce').val());
        fd.append('onlyupdate', 'true');
        fd.append('id', pid);

        var valid = true;
        $('.required').removeClass('invalid').each(function (ind, el) {
            if ($(el).attr("id") === "contact_person_email") {
                if ((!validateEmail($(el).val())) || ($(el).val() === '')) {
                    $(el).addClass('invalid');
                }
            } else {
                if ($(el).val() === '') {
                    valid = false;
                    $(el).addClass('invalid');
                }
            }
        });

        if (valid) {
            $.ajax({
                type: 'POST',
                url: ajaxurl,
                data: fd,
                dataType: 'json',
                contentType: false,
                processData: false,
                success: function (response) {
                    if (!payingpaid && !payingpremium) {
                        location.reload();
                    } else {
                        var pd = new FormData();
                        pd.append('id', pid);
                        pd.append('action', 'adv_get_payment_url');
                        pd.append('email', $('input[name=contact_person_email]').val());

                        var type = '';
                        if (payingpaid && !payingpremium) {
                            type = 'paid';
                        }
                        if (payingpaid && payingpremium) {
                            type = 'paidpremium';
                        }
                        if (!payingpaid && payingpremium) {
                            type = 'premium';
                        }

                        pd.append('type', type);

                        $.ajax({
                            type: 'POST',
                            url: ajaxurl,
                            data: pd,
                            dataType: 'json',
                            contentType: false,
                            processData: false,
                            success: function (response) {
                                window.location = response;
                            }
                        });
                    }
                },
                error: function(response) {
                    console.log('errorina')
                }
            });
        }
    });

    $('.delete-advert-photo').on('click', function () {
        var pid = $(this).data('pid');
        var photo = $(this).data('photo');

        var _this = $(this);

        var pd = new FormData();
        pd.append('postid', pid);
        pd.append('photo', photo);
        pd.append('action', 'delete_advert_photo');

        $.ajax({
            type: 'POST',
            url: ajaxurl,
            data: pd,
            dataType: 'json',
            contentType: false,
            processData: false,
            success: function (response) {
                if (response) {
                    _this.parent().remove();
                }
            }
        });
    });

    $('#premium').on('click', function () {
        if ($('#forma').hasClass('update')) {
            if ($(this).is(':checked')) {
                $('.create-advert').html('Išsaugoti ir apmokėti (2€)');
            } else {
                $('.create-advert').html('Išsaugoti');
            }
        } else {
            if ($(this).is(':checked')) {
                $('.create-advert').html('Įkelti ir apmokėti (3€)');
            } else {
                $('.create-advert').html('Įkelti ir apmokėti (1€)');
            }
        }
    });

    $('.adv-pay-func').on('click', function () {
        var pid = $(this).data('pid');
        var type = '';
        if ($('input[name=makepaid]').is(':checked')) {
            type = 'paid';
        }
        if ($('input[name=makepaidpremium]').is(':checked')) {
            type = 'paidpremium';
        }
        if ($('input[name=makepremium]').is(':checked')) {
            type = 'premium';
        }

        var pd = new FormData();
        pd.append('id', pid);
        pd.append('type', type);
        pd.append('action', 'adv_get_payment_url');
        pd.append('email', $('input[name=contact_person_email]').val());

        $.ajax({
            type: 'POST',
            url: ajaxurl,
            data: pd,
            dataType: 'json',
            contentType: false,
            processData: false,
            success: function (response) {
                window.location = response;
            }
        });
    });

    /////////////////////////////////////////

    var ais = $('.adv-images-slider').owlCarousel({
        loop: true,
        items: 1,
        nav: true
    });

    $('.adv-images-thumb').on('click', function () {
        var which = $(this).index();

        ais.trigger('to.owl.carousel', [which, 300]);
    });

    var catsel = $("#category").select2({
        dropdownParent: $("#category").parent(),
        "language": {
            "noResults": function () {
                return "Rezultatų nerasta";
            }
        }
    });
    var subcatsel = $("#subcategory").select2({
        dropdownParent: $("#subcategory").parent(),
        "language": {
            "noResults": function () {
                return "Rezultatų nerasta";
            }
        }
    });

    catsel.on("select2:select", function(e) {
        var pd = new FormData();
        var selid = e.params.data.id;

        pd.append('action', 'get_subcats');
        pd.append('cat', selid);

        $.ajax({
            type: 'POST',
            url: ajaxurl,
            data: pd,
            dataType: 'json',
            contentType: false,
            processData: false,
            success: function (response) {

                $('#subcategory option').remove();

                $.each(response, function( k, v ) {
                    $('#subcategory').append('<option value="' + k + '">' + v + '</option>');

                    subcatsel.select2('destroy');
                    subcatsel.select2({
                        dropdownParent: $("#subcategory").parent(),
                        "language": {
                            "noResults": function () {
                                return "Rezultatų nerasta";
                            }
                        }
                    });
                });
            },
            error: function(response){

            }
        });
    });

    catsel.on('select2:open', function () {
        setTimeout(function () {
            $(".select2-results__options").perfectScrollbar();
        }, 1);
        setTimeout(function () {
            $(".select2-results__options").perfectScrollbar('update');
        }, 2);
        setTimeout(function () {
            $(".select2-results__options").css('padding-right', '1px');
        }, 3);
    });
    subcatsel.on('select2:open', function () {
        setTimeout(function () {
            $(".select2-results__options").perfectScrollbar();
        }, 1);
        setTimeout(function () {
            $(".select2-results__options").perfectScrollbar('update');
        }, 2);
        setTimeout(function () {
            $(".select2-results__options").css('padding-right', '1px');
        }, 3);
    });



    $('.photo-wrap input').on('change', function (e) {
        var input = $(this);
        var preview = input.closest('.photo-wrap');
        var del = preview.find('.img-delete');
        var ovrl = preview.find('.img-preview');
        var label = preview.find('label');
        var image = URL.createObjectURL(e.target.files[0]);

        $('.photo-wrap').find('ul').remove();

        preview.css('background-image', 'url("' + image + '")');
        del.show();
        ovrl.show();
        label.hide();
    });

    $('body').on('click', '.img-delete:not(.del-curr)', function () {
        $(this).hide();
        $(this).prev().hide();
        $(this).parent().css('background-image', 'none');
        $(this).prev().prev().val('');
        $(this).prev().prev().prev().show();
    });

    $('.del-curr').on('click', function () {
        var pid = $(this).data('pid');
        var photo = $(this).data('photo');

        var _this = $(this);

        var pd = new FormData();
        pd.append('postid', pid);
        pd.append('photo', photo);
        pd.append('action', 'delete_advert_photo');

        $.ajax({
            type: 'POST',
            url: ajaxurl,
            data: pd,
            dataType: 'json',
            contentType: false,
            processData: false,
            success: function (response) {
                if (response) {
                    _this.hide();
                    _this.removeClass('del-curr');
                    _this.prev().hide();
                    _this.parent().css('background-image', 'none');
                    _this.prev().prev().val('').addClass('filecheck');
                    _this.prev().prev().prev().show();
                }
            }
        });
    });

    // var next_page_term = 2;
    // $('.adv-load-more-term').on('click', function (e) {
    //     e.preventDefault();
    //
    //     var data = {
    //         'action' : 'ran_load_more_adv_term',
    //         'next_page' : next_page_term,
    //         'term' : $(this).data('term'),
    //         'filter' : $(this).data('which')
    //     };
    //     $.get(ajaxurl, data, function(response){
    //         if( response.success === true ) {
    //             if( response.data.next_page > 0 ) {
    //                 $('.adverts-list').append( response.data.html );
    //                 next_page_term = response.data.next_page;
    //             } else {
    //                 $('.adverts-list').append( response.data.html );
    //                 $('.adv-load-more').hide();
    //                 console.log('nomore')
    //             }
    //         } else {
    //             $('.adv-load-more').hide();
    //             console.log('nomore 2')
    //         }
    //     });
    //     return false;
    // });

    $('.categories-sidebar .section-title').on('click', function () {
        $(this).toggleClass('active');
        $('.categories-sidebar .adverts-categories').toggleClass('active');
    });

})(jQuery);